import { memo } from 'react';

import { Button, Text } from '../../ui';
import {
  StyledButtonWrapper,
  StyledDescription,
  StyledHeading,
  StyledWrapper,
} from './TextBanner.style';

export interface TextBannerProps {
  title: string;
  description: string;
  buttonText: string;
  buttonIcon: string;
  onClick?: () => void;
}

export const TextBanner = memo(function TextBanner({
  title,
  description,
  buttonText,
  buttonIcon,
  onClick,
}: TextBannerProps) {
  return (
    <StyledWrapper>
      <StyledHeading>
        <Text size={'BodyLargeHeavy'}>{title}</Text>
      </StyledHeading>

      <StyledDescription>
        <Text size={'Small'}>{description}</Text>
      </StyledDescription>

      <StyledButtonWrapper>
        <Button
          variant={'primary'}
          onClick={() => onClick?.()}
          icon={{ name: buttonIcon, position: 'start' }}
        >
          {buttonText}
        </Button>
      </StyledButtonWrapper>
    </StyledWrapper>
  );
});
